<template>
  <el-dialog
    :title="$t('common.deleteConfirm')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div class="delete-content">
      <p>{{ $t('indexMenu.confirmDeleteMenu') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteIndexMenu" :loading="loading">{{ $t('common.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMallMenu } from '@/api/admin/shopProductType/shopProductTypeApi'

export default {
  name: 'DeleteMallMenu',
  data() {
    return {
      dialogVisible: false,
      deleteIndexMenuInfo: {},
      loading: false
    }
  },
  methods: {
    open(menu) {
      this.deleteIndexMenuInfo = { ...menu }
      this.dialogVisible = true
    },
    handleClose(done) {
      this.deleteIndexMenuInfo = {}
      done()
    },
    async deleteIndexMenu() {
      this.loading = true
      try {
        await deleteMallMenu(this.deleteIndexMenuInfo)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(this.$t('common.deleteFailed'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.delete-content {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}
</style>